import { useIsDemoMode } from '@/lib/demo-mode-store';
import { FlaskConical } from 'lucide-react';

/**
 * DemoFillButton — per-section "fill with plausible demo data"
 * affordance. Only renders when demo mode is on (useIsDemoMode).
 * The caller provides the onFill callback which applies the
 * section-appropriate demo values to its local state.
 */

interface Props {
  label?: string;
  onFill: () => void;
  className?: string;
}

export function DemoFillButton({ label = 'Fill demo data', onFill, className }: Props) {
  const on = useIsDemoMode();
  if (!on) return null;
  return (
    <button
      type="button"
      onClick={onFill}
      className={
        (className ?? '') +
        ' inline-flex items-center gap-1 border border-amber-500 bg-amber-500/20 text-amber-200 ' +
        'px-2 py-1 text-[11px] font-bold uppercase tracking-widest hover:bg-amber-500/30'
      }
      title="Demo mode — populate this section with plausible placeholder data"
    >
      <FlaskConical size={11} />
      {label}
    </button>
  );
}
